import { NOTE_TYPES } from '../../models/Note';
import type { BadgeVariant } from '../primitives/Badge';

export function getNoteTypeBadgeClassName(type?: string): string | null {
  const normalizedType = type?.trim().toLowerCase() || '';

  if (!normalizedType || normalizedType === 'general' || !NOTE_TYPES.includes(normalizedType)) {
    return null;
  }

  switch (normalizedType) {
    case 'meeting':
      return 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300';
    case 'phone call':
      return 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300';
    case 'email':
      return 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300';
    case 'in person':
      return 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300';
    case 'voice mail':
      return 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300';
    case 'text message':
      return 'bg-yellow-200 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300';
    default:
      return 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300';
  }
}

export function getNoteTypeBadgeVariant(type?: string): BadgeVariant | null {
  const normalizedType = type?.trim().toLowerCase() || '';

  if (!normalizedType || normalizedType === 'general' || !NOTE_TYPES.includes(normalizedType)) {
    return null;
  }

  switch (normalizedType) {
    case 'meeting':
    case 'phone call':
      return 'info';
    case 'email':
      return 'success';
    case 'in person':
      return 'danger';
    case 'voice mail':
    case 'text message':
      return 'warning';
    default:
      return 'default';
  }
}